import React, { useContext, useState, useEffect } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import { VehicleContext } from "../../Context/VehicleContext";
import ReCAPTCHA from "react-google-recaptcha";

const contactMethods = ["Call", "Text", "Email"];

const validationSchema = Yup.object({
  location: Yup.string().required("Location is required"),
  first_name: Yup.string().required("First name is required"),
  last_name: Yup.string().required("Last name is required"),
  email: Yup.string().email("Invalid email").required("Email is required"),
  phone: Yup.string().required("Phone number is required"),
  comments: Yup.string(),
  contactmethod: Yup.array().min(1, "Select at least one method"),
});


const CarFinderForm = () => {
    const { submitContactForm, vehicleListSearch } = useContext(VehicleContext);
      const recaptchaRef = React.useRef();
    
        
    const [vehicleYears, setVehicleYears] = useState([]);
    const [vehicleMakes, setVehicleMakes] = useState([]);
    const [vehicleModels, setVehicleModels] = useState([]);
    const [vehicleTrims, setVehicleTrims] = useState([]);

    const [vehicleYearData, setVehicleYearData] = useState([]);

    //console.log(vehicleModels,vehicleTrims);

    useEffect(() => {

        if (!vehicleYears || vehicleYears.length === 0) {

            getVehicleYears();
        }
    }, []);

    const getVehicleYears = async () => {
        const data = await vehicleListSearch({ 'subject': 'year' });
        console.log(data);
        setVehicleYears(data);
    }

    const getVehicleYearData = async (year) => {
        const data = await vehicleListSearch({ 'subject': 'yeardata', 'year': year });
        console.log(data);

        setVehicleYearData(data);

        let makes = [];

        if ('makes' in data) {
            data['makes'].map((make, i) => {
                makes.push(make.name);
            });

            setVehicleMakes(makes);
        }
    }

    const getVehicleModels = async (year, make) => {
        console.log(year, make,vehicleYearData);

        if ('makes' in vehicleYearData) {

            let models = [];

            vehicleYearData['makes'].filter((item) => item.name == make).map((make, i) => {
                console.log(make);
                if ('models' in make) {
                    make['models'].map((model, j) => {
                        models.push(model.name);
                    })
                }
            });

            setVehicleModels(models);
        }
    }

    const getVehicleTrims = async (year,make,model) => {        
        console.log(year,make,model,vehicleYearData);

        if('makes' in vehicleYearData) {

            let trims = [];

            vehicleYearData['makes'].filter((item) => item.name == make).map((make,i) => {
                console.log(make);
                if('models' in make) {
                    make['models'].filter((item) => item.name == model).map((model,j) => {
                        if('trims' in model) {
                            model['trims'].map((trim,k) => {
                                trims.push(trim.name);
                            })
                        }
                    })
                }
            });

            setVehicleTrims(trims);
        }
    }

    return (
        <>
            <Formik
                initialValues={{
                    location: "TAMPA, FL",
                    year:"",
                    make:"",
                    model:"",
                    mileage:"",
                    notes:"",
                    first_name: "",
                    last_name: "",
                    email: "",
                    phone: "",
                }}
                validationSchema={validationSchema}
                onSubmit={async (values, { resetForm }) => {
                    const token = await recaptchaRef.current.executeAsync();
                    recaptchaRef.current.reset(); // Reset after use
            
                    values.token = token;
            
                    console.log(values);
                    const data = await submitContactForm(values);
                    if (data.success) {
                      resetForm();
                      alert("Thank you for your submission. We'll be in touch soon!");
                    } else
                      alert("There was a problem with your submission");
                  }}
            >
                {({ values, setFieldValue }) => (
                    <Form>
                        <ReCAPTCHA
                            ref={recaptchaRef}
                            sitekey="6LckXRIsAAAAAAiOe2UBkXy7Uy-ROdiueqrr4Lzk" // Replace with your actual site key
                            size="invisible"
                        /> 
                        <div className="custom-form consign-form  wow reveal fadeInUp">
                            <div className="row mlr-35 wow reveal fadeInUp">
                                <div className="col-12">
                                    <div className="xs-title eurostile text-uppercase fw-700 mb-4">Vehicle Info</div>
                                </div>
                                <div className="col-md-6">
                                    <div className="form-group">
                                        <div className='cs-label mb-2'>Vehicle Year</div>
                                        <Field as="select" name="year" className="form-control"
                                            onChange={(e) => { setFieldValue('year', e.target.value); getVehicleYearData(e.target.value); }}
                                        >
                                            <option value="">Select</option>
                                            {vehicleYears && vehicleYears.map((v, i) => (
                                                <option key={i} value={v}>
                                                    {v}
                                                </option>
                                            ))}
                                        </Field>
                                        <ErrorMessage
                                            name="year"
                                            component="div"
                                            className="text-danger small"
                                        />
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className="form-group">
                                        <div className='cs-label mb-2'>Make</div>
                                        <Field as="select" name="make" className="form-control"
                                            onChange={(e) => { setFieldValue('make', e.target.value); getVehicleModels(values.year, e.target.value); }}
                                        >
                                            <option value="">Select</option>
                                            {vehicleMakes && vehicleMakes.map((v, i) => (
                                                <option key={i} value={v}>
                                                    {v}
                                                </option>
                                            ))}
                                        </Field>
                                        <ErrorMessage
                                            name="make"
                                            component="div"
                                            className="text-danger small"
                                        />
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className="form-group">
                                        <div className='cs-label mb-2'>Model</div>
                                        <Field as="select" name="model" className="form-control"
                                            onChange={(e) => { setFieldValue('model',e.target.value); {/*getVehicleTrims(values.year,values.make,e.target.value);*/} }}
                                        >
                                            <option value="">Select</option>
                                            {vehicleModels.map((v, i) => (
                                                <option key={i} value={v}>
                                                    {v}
                                                </option>
                                            ))}
                                        </Field>
                                        <ErrorMessage
                                            name="model"
                                            component="div"
                                            className="text-danger small"
                                        />
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className="form-group">
                                        <div className='cs-label mb-2'>Mileage</div>
                                        <Field type="text" name="mileage" className="form-control"/>
                                        <ErrorMessage
                                            name="mileage"
                                            component="div"
                                            className="text-danger small"
                                        />
                                    </div>
                                </div>
                                <div className="col-12">
                                    <div className="form-group">
                                        <div className='cs-label mb-2'>Notes</div>
                                        <Field as="textarea" name="notes" className="form-control h-101"/>
                                        <ErrorMessage
                                            name="notes"
                                            component="div"
                                            className="text-danger small"
                                        />
                                    </div>
                                </div>
                                <div className="col-12 pt-3">
                                    <div className="cs-hr"></div>
                                </div>
                                <div className="col-12">
                                    <div className="xs-title eurostile text-uppercase fw-700 mb-4">Contact Info</div>
                                </div>
                                <div className="col-md-6">
                                    <div className="form-group">
                                        <div className='d-flex align-items-center justify-content-between mb-2'>
                                            <div className='cs-label mb-0'>Full Name</div>
                                            <div className='cs-require'><span className="text-orange">*</span> Required</div>
                                        </div>
                                        <Field type="text" name="first_name" className="form-control" />
                                        <ErrorMessage
                                            name="first_name"
                                            component="div"
                                            className="text-danger small"
                                        />
                                    </div>
                                </div>

                                <div className="col-md-6">
                                    <div className="form-group">
                                        <div className='d-flex align-items-center justify-content-between mb-2'>
                                            <div className='cs-label mb-0'>Last Name</div>
                                            <div className='cs-require'><span className="text-orange">*</span> Required</div>
                                        </div>
                                        <Field type="text" name="last_name" className="form-control" />
                                        <ErrorMessage
                                            name="last_name"
                                            component="div"
                                            className="text-danger small"
                                        />
                                    </div>
                                </div>

                                <div className="col-md-6">
                                    <div className="form-group">
                                        <div className='d-flex align-items-center justify-content-between mb-2'>
                                            <div className='cs-label mb-0'>Email</div>
                                            <div className='cs-require'><span className="text-orange">*</span> Required</div>
                                        </div>
                                        <Field type="text" name="email" className="form-control" />
                                        <ErrorMessage
                                            name="email"
                                            component="div"
                                            className="text-danger small"
                                        />
                                    </div>
                                </div>

                                <div className="col-md-6">
                                    <div className="form-group">
                                        <div className="cs-label mb-2">Phone</div>
                                        <Field type="text" name="phone" className="form-control" />
                                        <ErrorMessage
                                            name="phone"
                                            component="div"
                                            className="text-danger small"
                                        />
                                    </div>
                                </div>
                                <div className="col-12 mt-md-4 mt-2">
                                    <div className="sl-location-box">
                                        <div className="d-md-flex align-items-center">
                                            <div className="xs-title fw-600 text-uppercase mb-4 mb-md-0">Select Location</div>
                                            <div className="location-options d-md-flex ms-auto">
                                                <label className="custom-radio me-md-5 mb-3 mb-md-0">
                                                    <Field type="radio" name="location" value="TAMPA, FL" />
                                                    <span className="radio-mark"></span> Tampa, FL
                                                </label>
                                                <label className="custom-radio">
                                                    <Field type="radio" name="location" value="SAN CLEMENTE, CA" />
                                                    <span className="radio-mark"></span> San Clemente, CA
                                                </label>
                                            </div>
                                        </div>
                                        <ErrorMessage
                                            name="location"
                                            component="div"
                                            className="text-danger small"
                                        />
                                    </div>
                                </div>
                                <div className="col-12 mt-md-5 mt-md-4 pt-4">
                                    <div className="text-center">
                                        <button
                                            type="submit"
                                            className="orange-white-btn font-1-2em fw-700 lg-btn text-uppercase d-inline-block w-330"
                                        >
                                            Send
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Form>
                )}
            </Formik>
        </>
    )
}

export default CarFinderForm